module.exports = __webpack_public_path__ + "static/biennale-medium-it-12a58500c007af7e00d3f1fc391faa60.otf";